import { combineReducers } from "@reduxjs/toolkit";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export type RoomState = {
    speakerList: string[];
    fileUploadProgress: Record<string, number>;
};

const speakerListSlice = createSlice({
    name: "speakerList",
    initialState: [] as string[],
    reducers: {
        setSpeakerList: (state, action: PayloadAction<string[]>) => {
            return action.payload;
        },
    },
});

const fileUploadProgressSlice = createSlice({
    name: "fileUploadProgress",
    initialState: {} as Record<string, number>,
    reducers: {
        setFileUploadProgress: (state, action: PayloadAction<{ messageId: string; uploaded: number }>) => {
            state[action.payload.messageId] = action.payload.uploaded;
        },
        clearFileUploadProgress: (state, action: PayloadAction<{ messageId: string }>) => {
            delete state[action.payload.messageId];
        },
    },
});

export const roomReducers = combineReducers({
    speakerList: speakerListSlice.reducer,
    fileUploadProgress: fileUploadProgressSlice.reducer,
});

// Export actions
export const { setSpeakerList } = speakerListSlice.actions;
export const { setFileUploadProgress, clearFileUploadProgress } = fileUploadProgressSlice.actions;
